import { InjectionToken } from '@angular/core';

/**
 * Token for BoardLockService (boards app only).
 * Used to optionally inject the service in shared components.
 */
export interface BoardLockServiceInterface {
  isLocked(): boolean;
  isLocked$: import('rxjs').Observable<boolean>;
  lock(): void;
  unlock(): void;
  toggle(): void;
  setLockedBoardRoute(workspaceId: string, sessionId: string, boardId: string): void;
  getLockedBoardRoute(): {
    workspaceId: string;
    sessionId: string;
    boardId: string;
  } | null;
  clearLockedBoardRoute(): void;
}

export const BOARD_LOCK_SERVICE_TOKEN = new InjectionToken<BoardLockServiceInterface>(
  'BOARD_LOCK_SERVICE',
);
